var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectFileType
    ? _c("select-dialog", {
        ref: "selectDialog",
        attrs: {
          title: _vm.title,
          "row-data": _vm.rowData,
          "column-defs": _vm.singleColumnDefs,
          "filter-keys": ["name", "documentTypeUuidStr"],
          value: _vm.fileTypeTemplateUuid,
          "event-name": _vm.eventName,
          "display-name-field": _vm.displayNameField,
          "show-office": true
        },
        on: { change: _vm.changeTrigger, selected: _vm.selectedHandle }
      })
    : _c("select-multi-dialog", {
        ref: "selectMultiDialog",
        attrs: {
          title: _vm.title,
          "row-data": _vm.rowData,
          "column-defs": _vm.multiColumnDefs,
          "filter-keys": ["name", "documentTypeUuidStr"],
          value: _vm.templateUuids,
          "event-name": _vm.eventName,
          "display-name-field": _vm.displayNameField,
          "show-office": true
        },
        on: { change: _vm.changeTrigger }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }